/**
 *  A constant for the zero hash.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000000000000000000000000000"``)
 */
export const ZeroHash: string = "0x0000000000000000000000000000000000000000000000000000000000000000";

